export default __webpack_public_path__ + "static/media/box-users-a-b.130af70b.svg";